import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../Global/Base/Rights/RightTypes";
import { EnumType } from "../../../OW.Remoting/Remoting/DataTypes/Enums";
import { createElement, registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { ComboBox } from "../../UI/UI/Controls/ComboBox";
import { Action } from "../Actions/Action";
import { DropDownMenuItem } from "./DropDownMenuItem";

export class DropDownMenuComboBoxItem extends DropDownMenuItem {
    private _secondCaptionElement: HTMLElement;
    private _comboBoxData: EnumType;
    public comboBox: ComboBox;

    public static createDropDownMenuComboBoxItem(comboBoxData: EnumType, fnc: () => Promise<void>): DropDownMenuComboBoxItem {
        const comboItem = new DropDownMenuComboBoxItem();
        comboItem._comboBoxData = comboBoxData;
        comboItem.priority = 3;
        comboItem.noCloseAfterSelect = true;
        comboItem.action = new Action(fnc, "");
        comboItem.visible = true;
        comboItem._initialize();
        return comboItem;
    }

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    protected override _constructor(): void {
        super._constructor();
    }

    public setCaptions(mainText: string, caption: string): void {
        if (mainText == undefined)
            this._captionElement.textContent = mainText;
        if (caption == undefined)
            this._secondCaptionElement.textContent = caption;
    }

    protected _initialize(): void {
        this.classList.add("DropDownMenuItem", "SecondCaptionItem", "ComboboxItem");
        const container = createElement({ type: "div", classes: "container", css: { display: "block", padding: "0px", height: "25px" } });
        this.comboBox = new ComboBox({ element: container, originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION });
        this.appendChild(container);
    }

    /**
     * vloží data (_comboboxdata) do comboboxu
     * nastaví listenery
     * zvolí defaultní hodnotu, je-li vložena
     * @param selectedItem defaultní vybraná hodnota comboboxu
     */
    public initializeCombo(selectedItem: string): void {
        this.comboBox.setData(this._comboBoxData).then(() => {
            this._setComboListener();
            if (selectedItem)
                this.comboBox.setDisplayedValueByName(selectedItem);
        });
    }

    protected _setComboListener(): void {
        this.comboBox.innerElement.addEventListener("change", (e) => {
            e.stopPropagation();
        });
        this.comboBox.innerElement.addEventListener("click", (e) => {
            e.stopPropagation();
        });
    }

    protected override _setListener(): void {
        super._setListener();
    }

    public finallyDispose(): void {
        this.comboBox.dispose();
        this.unregisterEventListener();
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuComboBoxItem", DropDownMenuComboBoxItem);
